import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'

/* A caixa do @cutilei/ui, que o CurrencyInput usa como `customInput`. */
export const Input = styled(BaseInput)`
  width: 100%;
`
